import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { enums } from '@adc/sdk';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import classnames from 'classnames/bind';
import getDisplayIndicator from '../../../utils/getDisplayIndicator';
const cx = classnames.bind(styles);
const MapPin = ({ listingId, dotAssetType = enums.AssetType.BankOwned, customClassName, style, isHovered, label, seen, lighterShadow, }) => {
    const dotClasses = cx('dot', { active: isHovered }, { 'lighter-box-shadow': lighterShadow }, customClassName);
    const dotColors = getDisplayIndicator({
        listing_configuration: {
            asset_type: dotAssetType,
            product_type: '',
        },
    });
    return label ? (_jsxs("div", { className: cx('label-container'), children: [_jsx("div", { className: dotClasses, style: {
                    backgroundColor: seen ? dotColors.colorFaded : dotColors.color,
                } }), label] })) : (_jsx("div", { className: dotClasses, id: listingId, style: {
            backgroundColor: seen ? dotColors.colorFaded : dotColors.color,
            ...style,
        } }));
};
MapPin.propTypes = {
    listingId: PropTypes.string,
    dotAssetType: PropTypes.oneOf(Object.values(enums.AssetType)),
    customClassName: PropTypes.string,
    style: PropTypes.object,
    isHovered: PropTypes.bool,
    lighterShadow: PropTypes.bool,
    seen: PropTypes.bool,
    label: PropTypes.string,
};
export default MapPin;
//# sourceMappingURL=index.js.map